export default __webpack_public_path__ + "static/media/1 - Озеленение набережных.2cb3bb18.jpg";